// extracted by mini-css-extract-plugin
export default {"stage":"Room_stage__bujl9","hint":"Room_hint__F14ae"};